import React from "react";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { FlowStepSequence } from "../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowEditContext } from "../FlowEditContext";

interface IBaseSequenceStrategy {
    sequence: FlowStepSequence;
    editContext: FlowEditContext;
}

export abstract class BaseSequenceStrategy extends React.Component<IBaseSequenceStrategy> {
    @AutoBind
    showStrategyDialog(event: React.MouseEvent<HTMLDivElement>) {
        const { sequence } = this.props;
        event.stopPropagation();
        this.props.editContext!.setSelectedSequenceStrategy(event.currentTarget, sequence);
    }

    @AutoBind
    showErrorMessageForSequenceStrategy(event: React.MouseEvent<HTMLDivElement>) {
        const { sequence } = this.props;
        event.stopPropagation();
        this.props.editContext!.setSelectedSequenceForError(event.currentTarget, sequence);
    }
}
